import { render, staticRenderFns } from "./Suitability.vue?vue&type=template&id=1e94fdbf&scoped=true"
import script from "./Suitability.vue?vue&type=script&lang=js"
export * from "./Suitability.vue?vue&type=script&lang=js"
import style0 from "./Suitability.vue?vue&type=style&index=0&id=1e94fdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94fdbf",
  null
  
)

export default component.exports